/* global angular */

export default function EditInsuranceCommentDialogController(
  $rootScope,
  $scope,
  $q,
  loaderService,
  ssDialogService,
  vmDataService,
) {
  const vm = this;

  vm.newProductInsuranceComment = getSanitizedContactModel(vm.productInsuranceComment);
  vm.handleEditInsuranceCommentFormSubmit = _handleEditInsuranceCommentFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handleEditInsuranceCommentFormSubmit() {
    if ($scope.editInsuranceCommentForm.$valid) {
      const isNew = vm.newProductInsuranceComment.productInsuranceCommentId <= 0;

      if (!isNew && angular.equals(vm.productInsuranceComment, vm.newProductInsuranceComment)) {
        // No need to save
        return _closeDialog(); // or return Promise.resolve();
      }

      return _saveInsuranceComment(isNew).then(() => {
       _closeDialog();
      });
    }
  }

  function _saveInsuranceComment(isNew) {
    loaderService.showViewLoader = true;
    return vmDataService.saveInsuranceComment(vm.newProductInsuranceComment).then((response) => {
      loaderService.showViewLoader = false;
      const savedInsuranceComment = response.data;

      angular.extend(vm.newProductInsuranceComment, savedInsuranceComment);
      angular.extend(vm.productInsuranceComment, vm.newProductInsuranceComment);
      if (isNew) {
        vm.addCallback(vm.productInsuranceComment);
      } else {
        vm.editCallback(vm.productInsuranceComment);
      }
      return true;
    });
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editInsuranceCommentDialog);
  }

  function getSanitizedContactModel(apiModel) {
    return {
      productInsuranceCommentId: apiModel.productInsuranceCommentId || apiModel.ProductInsuranceCommentID,
      productId: apiModel.productId || apiModel.ProductID,
      text: apiModel.text || apiModel.Text,
      // createdDate: apiModel.createdDate,
      // createUserId: apiModel.createUserId,
      // createdUser: apiModel.createdUser,
    };
  }
}

EditInsuranceCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'loaderService',
  'ssDialogService',
  'vmDataService',
];
